<template>
  <div class="app-router">
    <router-link class="btn btn-md btn-success" :to="'/seller/pesanan-saya'">&laquo; Kembali</router-link>
    <v-layout v-resize="onResize" column>
      <v-card id="panel-invoice" :loading="loading" elevation="0" outlined flat tile class="mb-5">
        <v-card-subtitle class="pa-0" v-if="data">
          <div class="d-flex justify-end pa-3">
            <v-btn
              color="success"
              elevation="2"
              dark
              min-width="140"
              :disabled="!data"
              :class="(isMobile) ? 'v-btn--block v-size--default' : 'v-size--small'"
              @click="handlePrint"
            >
              <v-icon color="white darken-1" small class="mr-2">mdi-printer</v-icon>
              <strong class="text-capitalize text-subtitle-2 font-weight-bold">Cetak</strong>
            </v-btn>
          </div>
          <hr />
        </v-card-subtitle>

        <v-card-text class="px-5" v-if="data">
          <div id="section-to-print"> 
            <table-shipping :data="data" :isMobile="isMobile" :grandWeightTotal="grandWeightTotal"/>
 
          </div>
        </v-card-text>

        <v-card-text v-else>
          <div
            class="d-flex align-center pa-5 justify-center text-subtitle-2 text-center"
            v-if="!loading"
          >Tidak ada invoice yang sesuai ditemukan.</div>

          <div class="d-flex align-center pa-5 justify-center text-subtitle-2 text-center" v-else>
            <v-progress-circular indeterminate color="green"></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";
import tableShipping from "./component/tableShipping.vue";
import {checkBrowser} from '@/helpers/index'
export default {
  components:{
    tableShipping
  },
  data() {
    return {
      loading: false,
      paramId: false,
      data: null,
      grandWeightTotal: 0,
      isMobile: false
    };
  },
  computed: {
    ...mapState("auth", ["isAuth", "userData"]),
    ...mapState("storeSeller", ["detailStore"]),
    ...mapState("transaksiSeller", ["detailPesanan"]),
    ...mapState("pembelianSeller", ["detailPembelian"])
  },
  methods: {
    statusCaption(status) {
      if (status === "created") return "Belum Dibayar";
      else if (status === "pending") return "Belum Dibayar";
      else if (status === "paid") return "Dibayar";
      else if (status === "processed") return "Dibayar";
      else if (status === "completed") return "Sudah Selesai";
      else if (status === "cancel") return "Dibatalkan";
    },
    colorStatus(status) {
      if (status === "paid") return "green white--text";
      else if (status === "pending") return "orange darken-1 white--text";
      else if (status === "processed") return "blue darken-1 white--text";
      else if (status === "on_delivery")
        return "deep-purple darken-1 white--text";
      else if (status === "completed")
        return "light-green darken-4 white--text";
      else if (status === "cancel") return "red white--text";
    },
    ...mapActions("storeSeller", ["getStoreDetail"]),
    ...mapActions("pembelianSeller", ["getPembelianDetail"]),
    ...mapActions("transaksiSeller", ["getPesananDetailShipment"]),
    handlePrint() {
      // window.print(); 
      let width = 378,
        height = 657,
        left = (screen.width - width) / 2,
        top = 0,
        disp_setting = "toolbar=no,location=no,";

      disp_setting += "directories=no,menubar=no,";
      disp_setting +=
        "scrollbars=yes,width=" +
        width +
        ", height=" +
        height +
        ", left=" +
        left +
        ", top=" +
        top;
      let browser = checkBrowser();
      let content_vlue = document.getElementById(
        "section-to-print"
      ).innerHTML;
      let docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write(
        '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
      );
      docprint.document.write(
        '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      );
      docprint.document.write(
        '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      docprint.document.write("<head><title>Print</title>");
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");
      docprint.document.write(
        "font-family:Verdana, Geneva, sans-serif; font-size:12px;}"
      );

    docprint.document.write(browser == 'Chrome' ?
        "@media print {tr {-webkit-print-color-adjust: exact;} @page {size: 100mm 150mm potrait; margin: 1rem 0.5rem 1rem 1rem; } html,body {width: 100mm; height:150mm;}} " :
        "@media print {tr {-webkit-print-color-adjust: exact;} @page {size: 100mm 150mm potrait; margin: 1rem 0.5rem 1rem 1rem;} html,body {width: 100mm; height:150mm;}} "
      );

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write(
        '</head><body onLoad="self.print();" onafterprint="window.close()">'
      );
      docprint.document.write(content_vlue);
      docprint.document.write("</body></html>");
      docprint.document.close();
      docprint.focus(); 
    },

    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },

  async mounted() {
    this.loading = await true;
    await this.getStoreDetail();
    this.paramId = await this.$route.params.id;
    if (this.paramId.split("-")[0] === "trx") {
      await this.getPesananDetailShipment({ id: this.paramId.split("-")[1] });
      this.data = await this.detailPesanan;
      this.grandWeightTotal = this.data.trx_detail.reduce(
        (accumulator, current) =>
          parseFloat(accumulator) +
          parseFloat(
            current.trx_detail_product_weight * current.trx_detail_quantity
          ),
        0
      );
    } else if (this.paramId.split("-")[0] === "po") {
      await this.getPembelianDetail({ po_id: this.paramId.split("-")[1] });
      this.data = await this.detailPembelian;
      this.grandWeightTotal = this.data.po_detail.reduce(
        (accumulator, current) =>
          parseFloat(accumulator) +
          parseFloat(
            current.po_detail_product_weight *
              current.po_detail_quantity_requested
          ),
        0
      );
    }

    this.loading = false;
  },

  created() {
    this.$store.dispatch("setPageTitle", `Shipment Label`);
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 599px) {
}
</style>